// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"7431bc8f","194":"9f0abab5","405":"56acd855","566":"f19bf4b8","717":"528c5d2c","845":"707ab777"}[chunkId] + ".chunk.js";
};